import _ from 'lodash'
import Vue from 'vue'
import * as types from '../../store/types'

const state = {}

const getters = {
    [types.errors.getters.item]: state => sid => state[sid],
    [types.errors.getters.items]: state => state,
    [types.errors.getters.first]: state => state[_.first(_.keys(state))]
}

const actions = {
    [types.errors.actions.reset] ({ commit }) {
        commit(types.errors.mutations.reset)
    },
    [types.errors.actions.forget] ({ commit }, { sid }) {
        commit(types.errors.mutations.forgot, sid)
    },
    [types.errors.actions.store] ({ commit }, { error, sid }) {
        commit(types.errors.mutations.stored, { sid, error })
    }
}

const mutations = {
    [types.errors.mutations.reset] (state) {
        state = {}
    },
    [types.errors.mutations.forgot] (state, sid) {
        Vue.prototype.$validator.reset(sid)

        Vue.delete(state, sid)
    },
    [types.errors.mutations.stored] (state, payload) {
        if ([422, 400].includes(_.get(payload.error, 'response.status'))) {
            Vue.prototype.$validator.set(payload.error.response.data, payload.sid)
        }

        Vue.set(state, payload.sid, payload.error)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
